module.exports = "/_next/static/images/404-Error@3x-13298497bdb9e676952f1f76d9f9a2b8.png";